import { ProductVariant, V12FinanceData, HitachiFinanceData } from '../../../types';

const { productCode } = window.globalProductDetails;

export function validateSelectedVariant(variants: ProductVariant[], selectedVariantCode: string): string {
  if (variants.length > 0 && selectedVariantCode === '') {
    return 'Please select a size before adding to your bag';
  }
  return isAvailableForPurchase(variants, selectedVariantCode) ? '' : 'Sorry, this size is out of stock';
}

function isAvailableForPurchase(variants: ProductVariant[] = [], selectedVariantCode: string = productCode): boolean {
  const selectedVariant = variants.find((variant) => variant.productCode === selectedVariantCode);
  return selectedVariant ? selectedVariant.availableForPurchase : true;
}

export function updateFinanceDataInTheDOM(financeData: HitachiFinanceData | V12FinanceData): void {
  const { selectedTerm, deferredTerm, isPaymentDeferred } = financeData;
  const mappedDepositValue = 'mappedDepositValue' in financeData ? financeData.mappedDepositValue : 0;
  const fixedDepositAmount = 'fixedDepositAmount' in financeData ? financeData.fixedDepositAmount : 0;
  const isFixedDepositSelected = 'isFixedDepositSelected' in financeData ? financeData.isFixedDepositSelected : false;

  const term = isPaymentDeferred ? deferredTerm : selectedTerm;
  const deposit = isFixedDepositSelected ? fixedDepositAmount : mappedDepositValue;
  if (term === null || !term.code || deposit === null) {
    return;
  }

  const update =
    (value) =>
    (inputElement): void => {
      inputElement.value = value;
    };

  const financeDataMap = {
    financeProductCode: term.code,
    financeDeposit: deposit,
    isFixedDeposit: isFixedDepositSelected
  };

  Object.entries(financeDataMap).forEach(([inputName, inputValue]) => {
    [...document.querySelectorAll(`.add_to_cart_form input[name="${inputName}"]`)].forEach(update(inputValue));
  });
}

export function updateVariantSelectorInTheDOM(value: string): Promise<void> {
  return new Promise((resolve) => {
    const variantSelectorElements = document.querySelectorAll('.variant-select');
    [...variantSelectorElements].forEach((element) => {
      if (element instanceof HTMLFormElement) {
        Array.from(element).forEach((radio) => {
          const radioEl = radio as HTMLInputElement;
          radioEl.checked = radioEl.value === value;
        });
      }
    });

    const onVariantsFetchedAndDomUpdated = (): void => {
      document.removeEventListener('PDP_PRODUCT_VARIANTS_FETCHED_AND_DOM_UPDATED', onVariantsFetchedAndDomUpdated);
      resolve();
    };

    document.addEventListener('PDP_PRODUCT_VARIANTS_FETCHED_AND_DOM_UPDATED', onVariantsFetchedAndDomUpdated);

    variantSelectorElements[0].dispatchEvent(new CustomEvent('change'));
  });
}

export function getVariantSelectionInTheDOM(): string {
  const variantSelectorElement = document.querySelector<HTMLFormElement>('.variant-select');
  return variantSelectorElement?.querySelector<HTMLInputElement>('input[type="radio"]:checked')?.value || '';
}
